import React from 'react';

import CountryInfo from '../CountryInfo';

const CANCELLATION_SECTION = {
    title: 'Compensation for Event Cancellations',
    content: (
        <p>
            Total of $80mn of compensation specifically for loss of ticket sales
            and other costs associated with event cancellations.
        </p>
    ),
    links: [
        {
            title: 'Large compensation scheme for culture, voluntary sector and sport',
            url: 'https://www.regjeringen.no/en/aktuelt/large-compensation-scheme-for-culture-voluntary-sector-and-sport/id2693889/',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Norway',
    lastUpdated: 'March 18, 2020',
    introSection: (
        <p>
            Norway has announced a specific policy of 900mn NOK ($80m) intended
            for loss of ticket sales and participation fees.
        </p>
    ),
    sections: [CANCELLATION_SECTION],
};

const NorwayInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default NorwayInfo;
